// src/services/emailSettingsService.js
import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api/";

class EmailSettingsService {
  get() {
    return axios.get(API_URL + "settings/email", {
      headers: buildHeaders(),
    });
  }

  update(payload) {
    return axios.put(API_URL + "settings/email", payload, {
      headers: buildHeaders(),
    });
  }

  sendTestEmail(email) {
    return axios.post(
      API_URL + "settings/email/test",
      { email },
      { headers: buildHeaders() }
    );
  }
}

export default new EmailSettingsService();
